import { createLazyFileRoute } from "@tanstack/react-router";

import { NewTestSpecPage } from "@/features/admin/routes/TestSpecsNew";

export const Route = createLazyFileRoute("/_auth/admin/tests/new")({
  component: NewTestSpecPage,
});
